class CustomerModel {
  CustomerId = null;
  CustomerName = '';
  Occupation = '';
  MobileNumber = '';
  EmailId = '';
  AddressLine1 = '';
  AddressLine2 = '';
  AddressLine3 = '';
  City = '';
  State = '';
  Country = '';
  PinNumber = '';
  OfficeAddressLine1 = '';
  OfficeAddressLine2 = '';
  OfficeAddressLine3 = '';
  OfficeCity = '';
  OfficeState = '';
  OfficeCountry = '';
  OfficePinNumber = '';
  Reference1Name = '';
  Reference1MobileNumber = '';
  Reference2Name = '';
  Reference2MobileNumber = '';
  AnualIncome = '';
  FamilyMemberName = '';
  FamilyMemberMobileNumber = '';
  DOB = '';
}

export default CustomerModel;